import {
    comMapping
} from '../../../../../util/Function/comMapping.js'

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: "suosq",
                label: '发票所属期',
                type: "datemonth",
                valueformat: 'yyyyMM'
            },
            {
                prop: "jzjtbs",
                label: '即征即退标识',
                type: "select",
                selectval: comMapping.$jzjtbs
            },
            {
                prop: "companyCode",
                label: '公司代码',
                type: "selectmore",
                width: "220px",
            },
            {
                prop: "jzjtsuosq",
                label: '即征即退所属期',
                type: "datemonth",
                valueformat: 'yyyyMM'
            },
            {
                prop: "kaiprq",
                label: '开票日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "isLock",
                label: '是否锁定',
                type: "select",
                selectval: comMapping.$isLock
            },
            {
                prop: "faphm",
                label: '发票号码',
                type: "input",
            },
            {
                prop: "createTime",
                label: '创建日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "beiz",
                label: '备注',
                type: "input",
            },
            {
                prop: "financialAnnotations",
                label: '财务批注',
                type: "input",
            },
            {
                prop: "faplx",
                label: '发票类型',
                type: "select",
                selectval: comMapping.$fplx
            },
        ],
        searchdata: {
            suosq: "",
            jzjtbs: "",
            companyCode: [],
            jzjtsuosq: "",
            kaiprq: [],
            isLock: "",
            faphm: "",
            createTime: [],
            beiz: "",
            financialAnnotations: "",
            faplx: "",
        },
        headData: [
            {
                title: "公司代码",
                prop: "companyCode",
                width: 80,
                custom: true
            },
            {
                title: "发票所属期",
                prop: "suosq",
                width: 80,
                custom: true
            },
            {
                title: "发票类型",
                prop: "faplx",
                custom: true,
                width: 80,
            },
            {
                title: "发票号码",
                prop: "faphm",
                width: 120,
                custom: true
            },
            {
                title: "即征即退标识",
                prop: "jzjtbs",
                width: 90,
                custom: true
            },
            {
                title: "未税金额合计",
                prop: "weisjehj",
                width: 110,
                AmountFormat: true,
                custom: true
            },
            {
                title: "税额合计",
                prop: "shuiehj",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "即征即退销售额",
                prop: "jzjtxse",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "退税税额",
                prop: "tuisse",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "财务批注",
                prop: "financialAnnotations",
                width: 80,
                custom: true
            },
            {
                title: "备注",
                prop: "beiz",
                width: 80,
                custom: true
            },
            {
                title: "购方名称",
                prop: "goufmc",
                width: 80,
                custom: true
            },
            {
                title: "购方税号",
                prop: "goufsbh",
                width: 80,
                custom: true
            },
            {
                title: "创建日期",
                prop: "createTime",
                width: 80,
                custom: true
            },
            {
                title: "开票日期",
                prop: "kaiprq",
                width: 80,
                custom: true
            },
            {
                title: "操作员",
                prop: "jzjtUpdateBy",
                width: 80,
                custom: true
            },
            {
                title: "是否锁定",
                prop: "isLock",
                width: 80,
                custom: true
            },
            {
                title: "即征即退所属期",
                prop: "jzjtsuosq",
                width: 100,
                custom: true
            },
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },
    }
    return obj
}
